/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
window.GridEditor=function(master) {
  this.master = master; // is the a GantEditor instance

  var editorTabel = $(`#workSpace_${master.ganttStore.getGanttId}`).find('#tasksEditHead').find('.gdfTable');
  if (!master.permissions.canSeeDep)
    editorTabel.find(".requireCanSeeDep").hide();

  this.gridified = $.gridify(editorTabel,{},master.ganttStore.getGanttId,this.master.topHeight);
  this.element = this.gridified.find(".gdfTable").eq(1);

  this.minAllowedDate=new Date(new Date().getTime()-3600000*24*365*20).format();
  this.maxAllowedDate=new Date(new Date().getTime()+3600000*24*365*30).format();

  this.taskRowMouseOver=function(row,isfromTr){
    if(this.master.ganttStore.isGridDragging)return;
    if(isfromTr)this.master.ganttStore.showLitterTool(row.attr('data-taskid'),row[0].offsetTop-$('.gantSVGBoxDiv').scrollTop()+61+this.master.topHeight);
    if(row.attr('class').indexOf('rowSelected')==-1){
      row.addClass("rowOver");
      var ganttRow=$('#gridGroup rect')[row[0].offsetTop/30];
      if(ganttRow){
        ganttRow.setAttribute('class','ganttSVGOverRow');
      }
    }
  }
  this.taskRowMouseOut=function(row,isfromTr){
    if(this.master.ganttStore.isGridDragging)return;
    if(isfromTr)this.master.ganttStore.closeLitterTool();
    row.removeClass("rowOver");
    if(row.attr('class').indexOf('rowSelected')==-1){
      var ganttRow=$('#gridGroup rect')[row[0].offsetTop/30];
      if(ganttRow){
        ganttRow.setAttribute('class','ganttLinesSVG');
      }
    }
  }


}


GridEditor.prototype.fillEmptyLines = function () {
  //console.debug("fillEmptyLines")
  var factory = new TaskFactory();
  var master = this.master;

  //console.debug("GridEditor.fillEmptyLines");
  var rowsToAdd = master.minRowsInEditor - this.element.find(".taskEditRow").length;
  var empty=this.element.find(".emptyRow").length;
  rowsToAdd=Math.max(rowsToAdd,empty>5?0:5-empty);

  //fill with empty lines
  for (var i = 0; i < rowsToAdd; i++) {
    var emptyRow = $(this.master.ganttStore.getTaskEmptyRowHtmlTemplate());//$.JST.createFromTemplate({}, "TASKEMPTYROW");
    if (!master.permissions.canSeeDep)
      emptyRow.find(".requireCanSeeDep").hide();

    //click on empty row create a task and fill above
    emptyRow.click(function (ev) {
      //console.debug("emptyRow.click")
      var emptyRow = $(this);
      //add on the first empty row only
      if (!master.permissions.canAdd || emptyRow.prevAll(".emptyRow").length > 0)
        return;
      var lastTask;
      var start = new Date().getTime();
      var level = 0;
      if (master.tasks[0]) {
        start = master.tasks[0].start;
        level = master.tasks[0].level + 1;
      }

      //fill all empty previouses
      var cnt=0;
      emptyRow.prevAll(".emptyRow").addBack().each(function () {
        cnt++;
        var ch = factory.build("tmp_fk" + new Date().getTime()+"_"+cnt, "", "", level, start, Date.workingPeriodResolution);
        var task = master.addTask(ch);
        lastTask = ch;
      });
      master.endTransaction();
      if (lastTask.rowElement) {
        lastTask.rowElement.find("[name=name]").focus();//focus to "name" input
      }
    });
    this.element.append(emptyRow);
  }
};


GridEditor.prototype.addTask = function (task, row, hideIfParentCollapsed) {
  //console.debug("GridEditor.addTask",task,row);
  //var prof = new Profiler("ganttGridEditor.addTask");

  //remove extisting row
  this.element.find("#tid_" + task.id).remove();

  var taskRow = $(this.master.ganttStore.getTaskRowHtmlTemplate(task));//$.JST.createFromTemplate(task, "TASKROW");
  if (!this.master.permissions.canSeeDep)
    taskRow.find(".requireCanSeeDep").hide();

  if (!this.master.permissions.canSeePopEdit)
    taskRow.find(".edit .teamworkIcon").hide();

  //save row element on task
  task.rowElement = taskRow;

  this.bindRowEvents(task, taskRow);

  if (typeof(row) != "number") {
    var emptyRow = this.element.find(".emptyRow:first"); //tries to fill an empty row
    if (emptyRow.length > 0)
      emptyRow.replaceWith(taskRow);
    else
      this.element.append(taskRow);
  } else {
    var tr = this.element.find("tr.taskEditRow").eq(row);
    if (tr.length > 0) {
      tr.before(taskRow);
    } else {
      this.element.append(taskRow);
    }

  }

  //[expand]
  if (hideIfParentCollapsed) {
    if (task.collapsed) taskRow.addClass('collapsed');
    var collapsedDescendant = this.master.getCollapsedDescendant();
    if (collapsedDescendant.indexOf(task) >= 0) taskRow.hide();
  }
  //prof.stop();
  return taskRow;
};

GridEditor.prototype.refreshExpandStatus = function (task) {
  //console.debug("refreshExpandStatus",task);
  if (!task) return;
  if (task.isParent()) {
    task.rowElement.addClass("isParent");
  } else {
    task.rowElement.removeClass("isParent");
  }


  var par = task.getParent();
  if (par && !par.rowElement.is("isParent")) {
    par.rowElement.addClass("isParent");
  }

};

GridEditor.prototype.refreshTaskRow = function (task) {
  var row = task.rowElement;
  row.find(".indentCell").css("padding-left", task.level * 10 + 18);
};

GridEditor.prototype.redraw = function () {
  //console.debug("GridEditor.prototype.redraw")
  //var prof = new Profiler("gantt.GridEditor.redraw");
  for (var i = 0; i < this.master.tasks.length; i++) {
    this.refreshTaskRow(this.master.tasks[i]);
  }
  // check if new empty rows are needed
  if (this.master.fillWithEmptyLines)
    this.fillEmptyLines();

  //prof.stop()

};

GridEditor.prototype.reset = function () {
  this.element.find("[data-taskid]").remove();
};


GridEditor.prototype.bindRowEvents = function (task, taskRow) {
  var self = this;
  //bind row selection
  taskRow.click(function (event) {
    var row = $(this);
    row.closest("table").find(".rowSelected").removeClass("rowSelected");
    row.removeClass("rowOver");
    row.addClass("rowSelected");
    //svg
    if($('#gridGroup rect')[row[0].offsetTop/30]){
      $('.ganttSVGSeletedRow').each((index,item)=>{
        item.setAttribute('class','ganttLinesSVG');
      });
      $('#gridGroup rect')[row[0].offsetTop/30].setAttribute('class','ganttSVGSeletedRow');
    }
    //set current task
    self.master.currentTask = self.master.getTask(row.attr("data-taskid"));
  });
  taskRow.mouseover(function(event){
    var row = $(this);
    self.taskRowMouseOver(row,true);
  });
  taskRow.mouseleave(function(event){
    var row = $(this);
    if(event.relatedTarget&&event.relatedTarget.parentNode&&event.relatedTarget.parentNode.getAttribute('class')){
      if(event.relatedTarget.parentNode.getAttribute('class').indexOf('litterTool')>-1){
        self.master.ganttStore.taskOutFun=()=>{self.taskRowMouseOut(row,true)};
        return;
      }
    }
    self.taskRowMouseOut(row,true);
  });

  self.bindRowExpandEvents(task, taskRow);

  taskRow.dblclick(function (ev) { 
    self.master.ganttStore.editTaskRow($(this),task);
  });
};


GridEditor.prototype.bindRowExpandEvents = function (task, taskRow) {
  var self = this;
  //expand collapse
  taskRow.find(".exp-controller").click(function () {
    var el = $(this);
    var taskId = el.closest("[data-taskid]").attr("data-taskid");
    var task = self.master.getTask(taskId);
    if (task.collapsed) {
      self.master.expand(task,false);
    } else {
      self.master.collapse(task,false);
    }
  });
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/lib/gantt/js/ganttGridEditor.js